import * as React from "react";

export const IconDashboard = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "28",
  height = "28",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.758 10.7005V21.4031C22.758 21.6869 22.649 21.9591 22.455 22.1598C22.261 22.3605 21.9979 22.4732 21.7235 22.4732H13.4477V10.7005H22.758ZM11.3787 17.1214V22.4732H3.10284C2.82848 22.4732 2.56536 22.3605 2.37135 22.1598C2.17735 21.9591 2.06836 21.6869 2.06836 21.4031V17.1214H11.3787V17.1214ZM11.3787 3.21045V14.9811H2.06836V4.2806C2.06836 3.99678 2.17735 3.72458 2.37135 3.52389C2.56536 3.3232 2.82848 3.21045 3.10284 3.21045H11.3787ZM21.7235 3.21045C21.9979 3.21045 22.261 3.3232 22.455 3.52389C22.649 3.72458 22.758 3.99678 22.758 4.2806V8.56015H13.4477V3.21045H21.7235Z"
        fill={colorIcon}
      />
    </svg>
  );
};
export const IconInvest = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "28",
  height = "28",
  style = null,
}) => {
  return (
    <svg
      style={style ? style : null}
      width={width}
      height={height}
      viewBox="0 0 28 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.587 5.55556V0H0V25H27.1739V5.55556H13.587ZM5.43478 22.2222H2.71739V19.4444H5.43478V22.2222ZM5.43478 16.6667H2.71739V13.8889H5.43478V16.6667ZM5.43478 11.1111H2.71739V8.33333H5.43478V11.1111ZM5.43478 5.55556H2.71739V2.77778H5.43478V5.55556ZM10.8696 22.2222H8.15217V19.4444H10.8696V22.2222ZM10.8696 16.6667H8.15217V13.8889H10.8696V16.6667ZM10.8696 11.1111H8.15217V8.33333H10.8696V11.1111ZM10.8696 5.55556H8.15217V2.77778H10.8696V5.55556ZM24.4565 22.2222H13.587V19.4444H16.3043V16.6667H13.587V13.8889H16.3043V11.1111H13.587V8.33333H24.4565V22.2222ZM21.7391 11.1111H19.0217V13.8889H21.7391V11.1111ZM21.7391 16.6667H19.0217V19.4444H21.7391V16.6667Z"
        fill={colorIcon}
      />
    </svg>
  );
};
export const IconInvestments = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "28",
  height = "28",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22.999C10.1333 22.999 8.41667 22.574 6.85 21.724C5.28333 20.874 4 19.7407 3 18.324V19.999C3 20.2824 2.90433 20.5197 2.713 20.711C2.521 20.903 2.28333 20.999 2 20.999C1.71667 20.999 1.47933 20.903 1.288 20.711C1.096 20.5197 1 20.2824 1 19.999V15.999C1 15.7157 1.096 15.478 1.288 15.286C1.47933 15.0947 1.71667 14.999 2 14.999H6C6.28333 14.999 6.521 15.0947 6.713 15.286C6.90433 15.478 7 15.7157 7 15.999C7 16.2824 6.90433 16.5197 6.713 16.711C6.521 16.903 6.28333 16.999 6 16.999H4.525C5.325 18.199 6.37933 19.1657 7.688 19.899C8.996 20.6324 10.4333 20.999 12 20.999C14.3333 20.999 16.346 20.2324 18.038 18.699C19.7293 17.1657 20.7 15.2657 20.95 12.999C20.9833 12.7157 21.096 12.478 21.288 12.286C21.4793 12.0947 21.7167 11.999 22 11.999C22.2833 11.999 22.5207 12.099 22.712 12.299C22.904 12.499 22.9833 12.7324 22.95 12.999C22.8333 14.399 22.4627 15.7074 21.838 16.924C21.2127 18.1407 20.4127 19.199 19.438 20.099C18.4627 20.999 17.3373 21.7074 16.062 22.224C14.7873 22.7407 13.4333 22.999 12 22.999ZM2 11.999C1.71667 11.999 1.47933 11.899 1.288 11.699C1.096 11.499 1.01667 11.2657 1.05 10.999C1.18333 9.59902 1.55833 8.29069 2.175 7.07402C2.79167 5.85736 3.58733 4.79902 4.562 3.89902C5.53733 2.99902 6.66267 2.29069 7.938 1.77402C9.21267 1.25736 10.5667 0.999023 12 0.999023C13.8667 0.999023 15.5833 1.42402 17.15 2.27402C18.7167 3.12402 20 4.25736 21 5.67402V3.99902C21 3.71569 21.096 3.47802 21.288 3.28602C21.4793 3.09469 21.7167 2.99902 22 2.99902C22.2833 2.99902 22.5207 3.09469 22.712 3.28602C22.904 3.47802 23 3.71569 23 3.99902V7.99902C23 8.28236 22.904 8.51969 22.712 8.71102C22.5207 8.90302 22.2833 8.99902 22 8.99902H18C17.7167 8.99902 17.4793 8.90302 17.288 8.71102C17.096 8.51969 17 8.28236 17 7.99902C17 7.71569 17.096 7.47802 17.288 7.28602C17.4793 7.09469 17.7167 6.99902 18 6.99902H19.475C18.675 5.79902 17.6207 4.83236 16.312 4.09902C15.004 3.36569 13.5667 2.99902 12 2.99902C9.66667 2.99902 7.65433 3.76569 5.963 5.29902C4.271 6.83236 3.3 8.73236 3.05 10.999C3.01667 11.2824 2.90433 11.5197 2.713 11.711C2.521 11.903 2.28333 11.999 2 11.999ZM11.975 18.999C11.7417 18.999 11.5377 18.9117 11.363 18.737C11.1877 18.5617 11.1 18.3574 11.1 18.124V17.699C10.4667 17.5657 9.925 17.3197 9.475 16.961C9.025 16.603 8.66667 16.1407 8.4 15.574C8.3 15.3574 8.30433 15.1324 8.413 14.899C8.521 14.6657 8.69167 14.5074 8.925 14.424C9.14167 14.3407 9.35833 14.3407 9.575 14.424C9.79167 14.5074 9.96667 14.6657 10.1 14.899C10.3333 15.3157 10.625 15.628 10.975 15.836C11.325 16.0447 11.7167 16.149 12.15 16.149C12.7 16.149 13.1707 16.0197 13.562 15.761C13.954 15.503 14.15 15.099 14.15 14.549C14.15 14.0657 13.946 13.674 13.538 13.374C13.1293 13.074 12.4 12.7324 11.35 12.349C10.3667 11.999 9.646 11.5824 9.188 11.099C8.72933 10.6157 8.5 9.98236 8.5 9.19902C8.5 8.51569 8.73333 7.89902 9.2 7.34902C9.66667 6.79902 10.3167 6.43236 11.15 6.24902V5.87402C11.15 5.64069 11.2377 5.43636 11.413 5.26102C11.5877 5.08636 11.7917 4.99902 12.025 4.99902C12.2583 4.99902 12.4623 5.08636 12.637 5.26102C12.8123 5.43636 12.9 5.64069 12.9 5.87402V6.24902C13.35 6.28236 13.771 6.43236 14.163 6.69902C14.5543 6.96569 14.8833 7.29069 15.15 7.67402C15.2833 7.87402 15.3043 8.09469 15.213 8.33602C15.121 8.57802 14.95 8.74902 14.7 8.84902C14.5167 8.93236 14.321 8.93669 14.113 8.86202C13.9043 8.78669 13.7167 8.64902 13.55 8.44902C13.3833 8.24902 13.175 8.09069 12.925 7.97402C12.675 7.85736 12.3833 7.79902 12.05 7.79902C11.4667 7.79902 11.021 7.92402 10.713 8.17402C10.4043 8.42402 10.25 8.76569 10.25 9.19902C10.25 9.63236 10.4417 9.97402 10.825 10.224C11.2083 10.474 11.9 10.7657 12.9 11.099C14.1 11.5324 14.9 12.0407 15.3 12.624C15.7 13.2074 15.9 13.849 15.9 14.549C15.9 15.5324 15.6 16.274 15 16.774C14.4 17.274 13.6833 17.599 12.85 17.749V18.124C12.85 18.3574 12.7627 18.5617 12.588 18.737C12.4127 18.9117 12.2083 18.999 11.975 18.999Z"
        fill={colorIcon}
      />
    </svg>
  );
};
//movements IconMovements
export const IconMovements = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "28",
  height = "28",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 35 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.0059 7.55685L26.4679 -3.29495e-07L26.4679 5.66764L13.2245 5.66764L13.2245 9.44606L26.4679 9.44606L26.4679 15.1137L34.0059 7.55685ZM7.53799 20.7813L20.7814 20.7813L20.7814 17.0029L7.53799 17.0029L7.53799 11.3353L3.80364e-05 18.8921L7.53799 26.449L7.53799 20.7813Z"
        fill={colorIcon}
      />
    </svg>
  );
};
//account IconAccount
export const IconAccount = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "28",
  height = "28",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9993 20.0001C18.166 20.0001 16.5966 19.3473 15.291 18.0417C13.9855 16.7362 13.3327 15.1667 13.3327 13.3334C13.3327 11.5001 13.9855 9.93064 15.291 8.62508C16.5966 7.31953 18.166 6.66675 19.9993 6.66675C21.8327 6.66675 23.4021 7.31953 24.7077 8.62508C26.0132 9.93064 26.666 11.5001 26.666 13.3334C26.666 15.1667 26.0132 16.7362 24.7077 18.0417C23.4021 19.3473 21.8327 20.0001 19.9993 20.0001ZM6.66602 33.3334V28.6667C6.66602 27.7223 6.90935 26.854 7.39602 26.0617C7.88157 25.2706 8.52713 24.6667 9.33268 24.2501C11.0549 23.389 12.8049 22.7429 14.5827 22.3117C16.3605 21.8817 18.166 21.6667 19.9993 21.6667C21.8327 21.6667 23.6382 21.8817 25.416 22.3117C27.1938 22.7429 28.9438 23.389 30.666 24.2501C31.4716 24.6667 32.1171 25.2706 32.6027 26.0617C33.0893 26.854 33.3327 27.7223 33.3327 28.6667V33.3334H6.66602Z"
        fill={colorIcon}
      />
    </svg>
  );
};
//referals, user*, IconReferals
export const IconReferals = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "28",
  height = "28",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8004 2.3999C9.52735 2.3999 8.30645 2.90562 7.40628 3.80579C6.5061 4.70596 6.00039 5.92686 6.00039 7.1999C6.00039 8.47294 6.5061 9.69384 7.40628 10.594C8.30645 11.4942 9.52735 11.9999 10.8004 11.9999C12.0734 11.9999 13.2943 11.4942 14.1945 10.594C15.0947 9.69384 15.6004 8.47294 15.6004 7.1999C15.6004 5.92686 15.0947 4.70596 14.1945 3.80579C13.2943 2.90562 12.0734 2.3999 10.8004 2.3999ZM4.81119 13.1999C4.49515 13.1986 4.18198 13.2598 3.88962 13.3798C3.59726 13.4998 3.33148 13.6764 3.1075 13.8994C2.88353 14.1223 2.70577 14.3873 2.58443 14.6791C2.46309 14.971 2.40055 15.2839 2.40039 15.5999C2.40039 17.6291 3.39999 19.1591 4.96239 20.1563C6.50079 21.1367 8.57439 21.5999 10.8004 21.5999C11.2924 21.5999 11.7796 21.5771 12.2524 21.5315C11.3103 20.3608 10.7978 18.9026 10.8004 17.3999C10.8004 15.8039 11.3668 14.3399 12.3088 13.1999H4.81239H4.81119ZM22.8004 17.3999C22.8004 18.8321 22.2315 20.2056 21.2188 21.2183C20.2061 22.231 18.8326 22.7999 17.4004 22.7999C15.9682 22.7999 14.5947 22.231 13.582 21.2183C12.5693 20.2056 12.0004 18.8321 12.0004 17.3999C12.0004 15.9677 12.5693 14.5942 13.582 13.5815C14.5947 12.5688 15.9682 11.9999 17.4004 11.9999C18.8326 11.9999 20.2061 12.5688 21.2188 13.5815C22.2315 14.5942 22.8004 15.9677 22.8004 17.3999ZM17.9716 14.2319C17.9369 14.107 17.8623 13.997 17.7591 13.9185C17.656 13.8401 17.53 13.7977 17.4004 13.7977C17.2708 13.7977 17.1448 13.8401 17.0416 13.9185C16.9385 13.997 16.8639 14.107 16.8292 14.2319L16.2568 16.0703H14.4004C13.8196 16.0703 13.5772 16.8467 14.0476 17.2031L15.5476 18.3395L14.9752 20.1779C14.7952 20.7539 15.4288 21.2339 15.8992 20.8775L17.3992 19.7411L18.8992 20.8775C19.3696 21.2339 20.0032 20.7539 19.8232 20.1779L19.2508 18.3395L20.7508 17.2031C21.2212 16.8467 20.9788 16.0703 20.398 16.0703H18.544L17.9704 14.2331L17.9716 14.2319Z"
        fill={colorIcon}
      />
    </svg>
  );
};
//lock, IconSecurity
export const IconSecurity = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "28",
  height = "28",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="3 2 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.45564 26.0879C6.82706 26.0879 6.28916 25.8643 5.84192 25.417C5.39392 24.969 5.16992 24.4307 5.16992 23.8022V12.3736C5.16992 11.745 5.39392 11.2067 5.84192 10.7587C6.28916 10.3115 6.82706 10.0879 7.45564 10.0879H8.59849V7.80218C8.59849 6.22122 9.15583 4.87341 10.2705 3.75875C11.3844 2.64484 12.7318 2.08789 14.3128 2.08789C15.8937 2.08789 17.2415 2.64484 18.3562 3.75875C19.4701 4.87341 20.0271 6.22122 20.0271 7.80218V10.0879H21.1699C21.7985 10.0879 22.3368 10.3115 22.7848 10.7587C23.232 11.2067 23.4556 11.745 23.4556 12.3736V23.8022C23.4556 24.4307 23.232 24.969 22.7848 25.417C22.3368 25.8643 21.7985 26.0879 21.1699 26.0879H7.45564ZM14.3128 20.3736C14.9414 20.3736 15.4796 20.15 15.9276 19.7027C16.3749 19.2547 16.5985 18.7165 16.5985 18.0879C16.5985 17.4593 16.3749 16.921 15.9276 16.473C15.4796 16.0258 14.9414 15.8022 14.3128 15.8022C13.6842 15.8022 13.1463 16.0258 12.6991 16.473C12.2511 16.921 12.0271 17.4593 12.0271 18.0879C12.0271 18.7165 12.2511 19.2547 12.6991 19.7027C13.1463 20.15 13.6842 20.3736 14.3128 20.3736ZM10.8842 10.0879H17.7414V7.80218C17.7414 6.8498 17.408 6.04027 16.7414 5.37361C16.0747 4.70694 15.2652 4.37361 14.3128 4.37361C13.3604 4.37361 12.5509 4.70694 11.8842 5.37361C11.2175 6.04027 10.8842 6.8498 10.8842 7.80218V10.0879Z"
        fill={colorIcon}
      />
    </svg>
  );
};
//birrete, IconAcademy
export const IconAcademy = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "28",
  height = "28",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 3L1 9L12 15L21 10.09V17H23V9M5 13.18V17.18L12 21L19 17.18V13.18L12 17L5 13.18Z"
        fill={colorIcon}
      />
    </svg>
  );
};
//?, IconHelpSupport
export const IconHelpSupport = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "28",
  height = "28",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.5222 13.6308L17.2879 14.8925C16.3005 15.8799 15.6834 16.7165 15.6834 18.7736H12.9405V18.0879C12.9405 16.5656 13.5577 15.1942 14.5451 14.2068L16.2457 12.4788C16.7531 11.9851 17.0548 11.2994 17.0548 10.5451C17.0548 9.81762 16.7658 9.11996 16.2514 8.60558C15.737 8.09119 15.0394 7.80221 14.3119 7.80221C13.5845 7.80221 12.8868 8.09119 12.3724 8.60558C11.8581 9.11996 11.5691 9.81762 11.5691 10.5451H8.82623C8.82623 9.09017 9.40419 7.69485 10.433 6.66608C11.4617 5.63731 12.857 5.05935 14.3119 5.05935C15.7668 5.05935 17.1622 5.63731 18.1909 6.66608C19.2197 7.69485 19.7977 9.09017 19.7977 10.5451C19.7957 11.7015 19.3373 12.8104 18.5222 13.6308M15.6834 24.2594H12.9405V21.5165H15.6834M14.3119 0.945068C12.511 0.945068 10.7276 1.2998 9.06371 1.98901C7.39982 2.67821 5.88797 3.6884 4.61448 4.96189C2.04255 7.53382 0.597656 11.0221 0.597656 14.6594C0.597656 18.2966 2.04255 21.7849 4.61448 24.3568C5.88797 25.6303 7.39982 26.6405 9.06371 27.3297C10.7276 28.0189 12.511 28.3736 14.3119 28.3736C17.9492 28.3736 21.4375 26.9287 24.0094 24.3568C26.5813 21.7849 28.0262 18.2966 28.0262 14.6594C28.0262 7.07535 21.8548 0.945068 14.3119 0.945068Z"
        fill={colorIcon}
      />
    </svg>
  );
};
//cerrar sesión, IconLogOut
export const IconLogOut = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "28",
  height = "28",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 29 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.57573 12C7.57573 11.7107 7.68975 11.4332 7.89272 11.2286C8.09568 11.024 8.37095 10.9091 8.65798 10.9091H18.3982V3.81818C18.3982 1.63636 16.1126 0 14.0692 0H3.78787C2.78359 0.00108288 1.82076 0.403702 1.11063 1.11952C0.400497 1.83533 0.00107428 2.80587 0 3.81818V20.1818C0.00107428 21.1941 0.400497 22.1647 1.11063 22.8805C1.82076 23.5963 2.78359 23.9989 3.78787 24H14.6103C15.6146 23.9989 16.5775 23.5963 17.2876 22.8805C17.9977 22.1647 18.3971 21.1941 18.3982 20.1818V13.0909H8.65798C8.37095 13.0909 8.09568 12.976 7.89272 12.7714C7.68975 12.5668 7.57573 12.2893 7.57573 12ZM27.8212 11.2289L22.41 5.77432C22.2054 5.57837 21.9329 5.47074 21.6507 5.47438C21.3685 5.47803 21.0988 5.59265 20.8993 5.79382C20.6997 5.99498 20.586 6.26677 20.5824 6.55124C20.5788 6.83571 20.6855 7.11034 20.8799 7.31659L24.4432 10.9091H18.3982V13.0909H24.4432L20.8799 16.6834C20.7752 16.7837 20.6915 16.9041 20.6336 17.0375C20.5758 17.171 20.545 17.3147 20.5432 17.4603C20.5414 17.6059 20.5684 17.7504 20.6229 17.8853C20.6773 18.0202 20.7579 18.1427 20.8601 18.2457C20.9622 18.3486 21.0838 18.43 21.2176 18.4848C21.3514 18.5397 21.4948 18.567 21.6392 18.5651C21.7837 18.5632 21.9263 18.5323 22.0586 18.474C22.191 18.4157 22.3105 18.3312 22.41 18.2257L27.8212 12.7711C28.024 12.5666 28.1379 12.2892 28.1379 12C28.1379 11.7108 28.024 11.4334 27.8212 11.2289V11.2289Z"
        fill={colorIcon}
      />
    </svg>
  );
};
//Caja sesión, IconBoxBriefcase
export const IconBoxBriefcase = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "28",
  height = "28",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 82 76"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="82" height="76" rx="15" fill="#312478" />
      <g clipPath="url(#clip0_1397_54045)">
        <path
          d="M64 37.1386V55.4709C63.9736 55.5545 63.9376 55.6352 63.9232 55.7216C63.3772 58.9602 61.3396 60.993 58.5953 60.9944C46.8763 61.0002 35.1561 61.0002 23.4371 60.9944C20.2775 60.993 18.012 58.2528 18.0108 54.4596C18.0096 48.8886 18.0108 43.319 18.0108 37.748C18.0108 37.5593 18.0108 37.3692 18.0108 37.1401C18.1788 37.1992 18.2928 37.2337 18.4044 37.2784C25.3367 40.0502 32.2725 42.8062 39.1952 45.6082C40.4312 46.1081 41.5916 46.1081 42.8264 45.6097C49.8774 42.763 56.9405 39.9566 64 37.1372V37.1386Z"
          fill={colorIcon}
        />
        <path
          d="M63.9995 33.4725C61.2515 34.5803 58.5048 35.694 55.7556 36.7961C51.1201 38.6531 46.481 40.4971 41.8491 42.3671C41.2647 42.6033 40.7391 42.5932 40.1523 42.357C32.9404 39.4541 25.7238 36.5684 18.5023 33.7015C18.0931 33.5402 17.9911 33.3212 17.9995 32.8371C18.0259 31.3461 18.0067 29.8536 18.0103 28.3625C18.0163 24.6773 20.2939 21.9242 23.3706 21.9112C26.4989 21.8968 29.6285 21.9084 32.7568 21.9084C32.932 21.9084 33.1084 21.9084 33.352 21.9084C33.352 21.067 33.3364 20.2819 33.3544 19.4982C33.406 17.3069 34.624 15.5522 36.4072 15.0998C36.6832 15.0293 36.9712 15.0105 37.2544 15.0105C39.7539 15.0033 42.2547 14.9932 44.7542 15.0105C46.703 15.0235 48.2006 16.4742 48.5846 18.6971C48.6506 19.0804 48.6518 19.4823 48.6578 19.8756C48.6686 20.521 48.6614 21.1664 48.6614 21.9069C48.8642 21.9069 49.0358 21.9069 49.2074 21.9069C52.2757 21.9069 55.3464 21.9732 58.4136 21.8882C61.4831 21.8046 63.6131 24.454 63.9311 27.2359C63.9395 27.305 63.9755 27.3684 63.9983 27.4347V33.4739L63.9995 33.4725ZM37.1872 21.8666H44.813V19.6393H37.1872V21.8666V21.8666Z"
          fill={colorIcon}
        />
      </g>
      <defs>
        <clipPath id="clip0_1397_54045">
          <rect
            width="46"
            height="46"
            fill="white"
            transform="translate(18 15)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
//Icon_box_saving, pig save
export const IconBoxSaving = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "28",
  height = "28",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 82 76"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="82" height="76" rx="15" fill="#312478" />
      <path
        d="M18 50.1197V39.3407C19.0782 39.3407 20.1565 39.3508 21.2347 39.3283C21.3799 39.3249 21.5994 39.1899 21.6546 39.0605C22.582 36.8915 24.0339 35.1274 25.8393 33.6412C26.1004 33.4264 26.187 33.2103 26.1848 32.8841C26.1713 30.7139 26.178 28.5426 26.178 26.3712C26.178 26.2126 26.178 26.054 26.178 25.8661C26.5179 25.8661 26.8004 25.8695 27.0818 25.8661C30.06 25.8222 32.58 26.846 34.6014 29.0623C34.7072 29.1782 34.9706 29.2345 35.1349 29.1996C38.5408 28.4773 41.9612 28.3423 45.3974 28.9251C50.0053 29.7059 54.145 31.4598 57.4889 34.8304C57.6454 34.9879 57.7658 35.0453 57.9864 34.9339C59.9943 33.9247 61.1513 32.3396 61.3033 30.0737C61.3607 29.2311 60.7799 28.5831 59.9943 28.5662C59.2245 28.5504 58.6381 29.1456 58.6212 29.9736C58.6122 30.3888 58.6201 30.8039 58.6201 31.2292H55.9301C55.9301 30.7386 55.9087 30.2751 55.9334 29.815C56.0629 27.4805 58.01 25.6883 60.1913 25.8841C62.6258 26.1024 64.2094 28.0565 63.9775 30.4855C63.7445 32.9358 62.6472 34.89 60.718 36.3886C60.3095 36.7058 59.8615 36.9714 59.4158 37.2717C59.4946 37.4157 59.5655 37.5451 59.6375 37.6745C61.6916 41.3388 61.7715 45.0413 59.8311 48.7708C58.781 50.7879 57.239 52.3788 55.4472 53.7535C55.2063 53.9381 55.0015 54.2373 54.9025 54.5253C54.2114 56.547 53.5462 58.5777 52.8912 60.6118C52.7977 60.9009 52.6807 61.001 52.3678 60.9999C50.0616 60.9842 47.7543 60.992 45.4481 60.9898C45.3198 60.9898 45.1926 60.9729 45.0226 60.9617V57.8993C42.3236 58.2942 39.6685 58.2841 36.9538 57.8971V60.9752H29.2473C28.5326 58.8083 27.8303 56.6483 27.0965 54.4994C26.9985 54.2126 26.7881 53.9178 26.5472 53.7333C25.2911 52.7714 24.151 51.6981 23.2202 50.4156C23.0468 50.1759 22.8589 50.1152 22.5831 50.1163C21.0558 50.1276 19.5273 50.1219 18 50.1219V50.1197ZM39.6561 36.8645C39.6066 36.8982 39.583 36.9174 39.5571 36.9309C39.4637 36.977 39.368 37.0197 39.2746 37.067C37.8441 37.7926 37.0281 38.957 36.983 40.5557C36.938 42.1623 37.6302 43.4493 39.0799 44.1918C39.6719 44.4945 40.3776 44.607 41.0462 44.7195C41.7845 44.8432 42.3225 45.3259 42.3495 46.0268C42.3754 46.7052 41.8678 47.3105 41.1891 47.4106C40.5082 47.5107 39.8891 47.0731 39.6877 46.3474C39.6652 46.2653 39.6505 46.1798 39.6359 46.1078H36.9605C37.0494 47.6806 37.7293 48.8788 39.1001 49.5875C39.5774 49.8339 39.6922 50.0927 39.6685 50.5719C39.6325 51.3111 39.6584 52.0547 39.6584 52.7894H42.354C42.354 51.9614 42.3698 51.1558 42.3461 50.3514C42.336 50.0139 42.4216 49.8362 42.7513 49.6753C44.1931 48.971 44.9922 47.7841 45.0294 46.1865C45.0665 44.5991 44.3788 43.3233 42.9505 42.583C42.3608 42.277 41.6551 42.1567 40.9865 42.0475C40.2223 41.9215 39.6753 41.4333 39.6607 40.7155C39.646 40.054 40.1379 39.4678 40.7997 39.3576C41.4953 39.2417 42.1289 39.6883 42.3293 40.4387C42.3506 40.5186 42.3664 40.5996 42.381 40.6637H45.0136C45.089 39.2372 44.156 37.724 42.7772 37.0974C42.4317 36.9399 42.3349 36.7508 42.3461 36.3942C42.372 35.5921 42.354 34.7877 42.354 33.9832H39.6573V36.8645H39.6561ZM26.2107 39.3598V41.9991H28.8489V39.3598H26.2107Z"
        fill={colorIcon}
      />
      <path
        d="M41.6346 15.0011C42.5755 15.2025 43.4726 15.4995 44.2548 16.0935C46.1896 17.5628 46.9133 20.1482 46.0028 22.4084C45.1192 24.6045 42.7905 26.0186 40.4888 25.7587C37.9857 25.4752 36.0565 23.6437 35.6862 21.199C35.2428 18.2761 37.2169 15.5569 40.123 15.081C40.2097 15.0664 40.2919 15.0281 40.3751 15C40.795 15 41.2137 15 41.6335 15L41.6346 15.0011Z"
        fill={colorIcon}
      />
    </svg>
  );
};
//Icon_box_graph
export const IconBoxGraph = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "28",
  height = "28",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 82 76"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="82" height="76" rx="15" fill="#312478" />
      <path
        d="M58.2498 30.3333C55.3748 30.3333 53.8415 33.0167 54.6082 35.125L47.7082 42.025C47.1332 41.8333 46.3665 41.8333 45.7915 42.025L40.8082 37.0417C41.5748 34.9333 40.0415 32.25 37.1665 32.25C34.4832 32.25 32.7582 34.9333 33.5248 37.0417L24.7082 45.6667C22.5998 45.0917 19.9165 46.625 19.9165 49.5C19.9165 51.6083 21.6415 53.3333 23.7498 53.3333C26.4332 53.3333 28.1582 50.65 27.3915 48.5417L36.0165 39.725C36.5915 39.9167 37.3582 39.9167 37.9332 39.725L42.9165 44.7083C42.3415 46.625 43.8748 49.5 46.7498 49.5C49.6248 49.5 51.1582 46.8167 50.3915 44.7083L57.2915 37.8083C59.3998 38.3833 62.0832 36.85 62.0832 34.1667C62.0832 32.0583 60.3582 30.3333 58.2498 30.3333ZM46.7498 32.25L48.4748 28.225L52.4998 26.5L48.4748 24.775L46.7498 20.75L45.0248 24.775L40.9998 26.5L45.0248 28.225L46.7498 32.25ZM24.7082 36.0833L25.6665 32.25L29.4998 31.2917L25.6665 30.3333L24.7082 26.5L23.7498 30.3333L19.9165 31.2917L23.7498 32.25L24.7082 36.0833Z"
        fill={colorIcon}
      />
    </svg>
  );
};
//IconBoxEye
export const IconBoxEye = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "29",
  height = "22",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="9 9 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.75 15C17.9363 15 17.1559 15.3161 16.5805 15.8787C16.0051 16.4413 15.6818 17.2044 15.6818 18C15.6818 18.7956 16.0051 19.5587 16.5805 20.1213C17.1559 20.6839 17.9363 21 18.75 21C19.5637 21 20.3441 20.6839 20.9195 20.1213C21.4949 19.5587 21.8182 18.7956 21.8182 18C21.8182 17.2044 21.4949 16.4413 20.9195 15.8787C20.3441 15.3161 19.5637 15 18.75 15ZM18.75 23C17.3938 23 16.0931 22.4732 15.1341 21.5355C14.1751 20.5979 13.6364 19.3261 13.6364 18C13.6364 16.6739 14.1751 15.4021 15.1341 14.4645C16.0931 13.5268 17.3938 13 18.75 13C20.1062 13 21.4069 13.5268 22.3659 14.4645C23.3249 15.4021 23.8636 16.6739 23.8636 18C23.8636 19.3261 23.3249 20.5979 22.3659 21.5355C21.4069 22.4732 20.1062 23 18.75 23ZM18.75 10.5C13.6364 10.5 9.26932 13.61 7.5 18C9.26932 22.39 13.6364 25.5 18.75 25.5C23.8636 25.5 28.2307 22.39 30 18C28.2307 13.61 23.8636 10.5 18.75 10.5Z"
        fill={colorIcon}
      />
    </svg>
  );
};
//IconBoxEyeOff
export const IconBoxEyeOff = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "29",
  height = "22",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="9 9 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.76 14.6842L20.7632 17.6779V17.5263C20.7632 16.7725 20.4637 16.0496 19.9307 15.5166C19.3977 14.9836 18.6748 14.6842 17.9211 14.6842H17.76ZM13.6863 15.4421L15.1547 16.9105C15.1074 17.1095 15.0789 17.3084 15.0789 17.5263C15.0789 18.2801 15.3784 19.003 15.9114 19.536C16.4444 20.069 17.1673 20.3684 17.9211 20.3684C18.1295 20.3684 18.3379 20.34 18.5368 20.2926L20.0053 21.7611C19.3705 22.0737 18.6695 22.2632 17.9211 22.2632C16.6648 22.2632 15.4599 21.7641 14.5716 20.8758C13.6833 19.9874 13.1842 18.7826 13.1842 17.5263C13.1842 16.7779 13.3737 16.0768 13.6863 15.4421ZM8.44737 10.2032L10.6074 12.3632L11.0337 12.7895C9.47053 14.0211 8.23895 15.6316 7.5 17.5263C9.13895 21.6853 13.1842 24.6316 17.9211 24.6316C19.3895 24.6316 20.7916 24.3474 22.0705 23.8358L22.4779 24.2337L25.2442 27L26.4474 25.7968L9.65053 9M17.9211 12.7895C19.1773 12.7895 20.3822 13.2885 21.2705 14.1769C22.1588 15.0652 22.6579 16.27 22.6579 17.5263C22.6579 18.1326 22.5347 18.72 22.3168 19.2505L25.0926 22.0263C26.5137 20.8421 27.6505 19.2884 28.3421 17.5263C26.7032 13.3674 22.6579 10.4211 17.9211 10.4211C16.5947 10.4211 15.3253 10.6579 14.1316 11.0842L16.1874 13.1211C16.7274 12.9126 17.3053 12.7895 17.9211 12.7895Z"
        fill={colorIcon}
      />
    </svg>
  );
};
//IconBoxEyeOff
export const IconBoxMap = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "29",
  height = "22",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="9 8 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="47" height="44" rx="4" fill="#312478" />
      <path
        d="M23.4987 8.66406C27.912 8.66406 31.4987 12.2107 31.4987 16.5974C31.4987 22.5441 23.4987 31.3307 23.4987 31.3307C23.4987 31.3307 15.4987 22.5441 15.4987 16.5974C15.4987 12.2107 19.0854 8.66406 23.4987 8.66406ZM23.4987 13.9974C22.7915 13.9974 22.1132 14.2783 21.6131 14.7784C21.113 15.2785 20.832 15.9568 20.832 16.6641C20.832 17.3713 21.113 18.0496 21.6131 18.5497C22.1132 19.0498 22.7915 19.3307 23.4987 19.3307C24.2059 19.3307 24.8842 19.0498 25.3843 18.5497C25.8844 18.0496 26.1654 17.3713 26.1654 16.6641C26.1654 15.9568 25.8844 15.2785 25.3843 14.7784C24.8842 14.2783 24.2059 13.9974 23.4987 13.9974M34.1654 31.3307C34.1654 34.2774 29.392 36.6641 23.4987 36.6641C17.6054 36.6641 12.832 34.2774 12.832 31.3307C12.832 29.6107 14.4587 28.0774 16.9787 27.1041L17.832 28.3174C16.392 28.9174 15.4987 29.7441 15.4987 30.6641C15.4987 32.5041 19.0854 33.9974 23.4987 33.9974C27.912 33.9974 31.4987 32.5041 31.4987 30.6641C31.4987 29.7441 30.6054 28.9174 29.1654 28.3174L30.0187 27.1041C32.5387 28.0774 34.1654 29.6107 34.1654 31.3307Z"
        fill={colorIcon}
      />
    </svg>
  );
};
export const IconBoxMapW = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "29",
  height = "22",
  style = null,
  fillOpacity = "1.0",
}) => {
  return (
    <svg
      style={style ? style : null}
      width={width}
      height={height}
      viewBox="9 8 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="47"
        height="44"
        rx="4"
        fill="#ffffff"
        fillOpacity={fillOpacity}
      />
      <path
        d="M23.4987 8.66406C27.912 8.66406 31.4987 12.2107 31.4987 16.5974C31.4987 22.5441 23.4987 31.3307 23.4987 31.3307C23.4987 31.3307 15.4987 22.5441 15.4987 16.5974C15.4987 12.2107 19.0854 8.66406 23.4987 8.66406ZM23.4987 13.9974C22.7915 13.9974 22.1132 14.2783 21.6131 14.7784C21.113 15.2785 20.832 15.9568 20.832 16.6641C20.832 17.3713 21.113 18.0496 21.6131 18.5497C22.1132 19.0498 22.7915 19.3307 23.4987 19.3307C24.2059 19.3307 24.8842 19.0498 25.3843 18.5497C25.8844 18.0496 26.1654 17.3713 26.1654 16.6641C26.1654 15.9568 25.8844 15.2785 25.3843 14.7784C24.8842 14.2783 24.2059 13.9974 23.4987 13.9974M34.1654 31.3307C34.1654 34.2774 29.392 36.6641 23.4987 36.6641C17.6054 36.6641 12.832 34.2774 12.832 31.3307C12.832 29.6107 14.4587 28.0774 16.9787 27.1041L17.832 28.3174C16.392 28.9174 15.4987 29.7441 15.4987 30.6641C15.4987 32.5041 19.0854 33.9974 23.4987 33.9974C27.912 33.9974 31.4987 32.5041 31.4987 30.6641C31.4987 29.7441 30.6054 28.9174 29.1654 28.3174L30.0187 27.1041C32.5387 28.0774 34.1654 29.6107 34.1654 31.3307Z"
        fill={colorIcon}
      />
    </svg>
  );
};
//IconBoxEyeOff
export const IconBoxInfo = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "29",
  height = "22",
  style = null,
}) => {
  return (
    <svg
      style={style ? style : null}
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6665 22.668H17.3332V14.668H14.6665V22.668ZM15.9998 12.0013C16.3776 12.0013 16.6945 11.8733 16.9505 11.6173C17.2056 11.3622 17.3332 11.0457 17.3332 10.668C17.3332 10.2902 17.2056 9.9733 16.9505 9.7173C16.6945 9.46219 16.3776 9.33464 15.9998 9.33464C15.6221 9.33464 15.3056 9.46219 15.0505 9.7173C14.7945 9.9733 14.6665 10.2902 14.6665 10.668C14.6665 11.0457 14.7945 11.3622 15.0505 11.6173C15.3056 11.8733 15.6221 12.0013 15.9998 12.0013ZM15.9998 29.3346C14.1554 29.3346 12.4221 28.9844 10.7998 28.284C9.17762 27.5844 7.7665 26.6346 6.5665 25.4346C5.3665 24.2346 4.41673 22.8235 3.71717 21.2013C3.01673 19.5791 2.6665 17.8457 2.6665 16.0013C2.6665 14.1569 3.01673 12.4235 3.71717 10.8013C4.41673 9.17908 5.3665 7.76797 6.5665 6.56797C7.7665 5.36797 9.17762 4.41775 10.7998 3.7173C12.4221 3.01775 14.1554 2.66797 15.9998 2.66797C17.8443 2.66797 19.5776 3.01775 21.1998 3.7173C22.8221 4.41775 24.2332 5.36797 25.4332 6.56797C26.6332 7.76797 27.5829 9.17908 28.2825 10.8013C28.9829 12.4235 29.3332 14.1569 29.3332 16.0013C29.3332 17.8457 28.9829 19.5791 28.2825 21.2013C27.5829 22.8235 26.6332 24.2346 25.4332 25.4346C24.2332 26.6346 22.8221 27.5844 21.1998 28.284C19.5776 28.9844 17.8443 29.3346 15.9998 29.3346Z"
        fill={colorIcon}
      />
    </svg>
  );
};
//IconBoxSecurity shield
export const IconBoxSecurity = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "29",
  height = "22",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 26C7.10417 25.2417 4.71375 23.5135 2.82875 20.8156C0.942917 18.1185 0 15.1233 0 11.83V3.9L10 0L20 3.9V11.83C20 15.1233 19.0575 18.1185 17.1725 20.8156C15.2867 23.5135 12.8958 25.2417 10 26Z"
        fill={colorIcon}
      />
    </svg>
  );
};
//IconBoxEmail carta
export const IconBoxEmail = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "29",
  height = "22",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 27 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 5.33333L13.3333 12L2.66667 5.33333V2.66667L13.3333 9.33333L24 2.66667M24 0H2.66667C1.18667 0 0 1.18667 0 2.66667V18.6667C0 19.3739 0.280951 20.0522 0.781048 20.5523C1.28115 21.0524 1.95942 21.3333 2.66667 21.3333H24C24.7072 21.3333 25.3855 21.0524 25.8856 20.5523C26.3857 20.0522 26.6667 19.3739 26.6667 18.6667V2.66667C26.6667 1.95942 26.3857 1.28115 25.8856 0.781048C25.3855 0.280951 24.7072 0 24 0V0Z"
        fill={colorIcon}
      />
    </svg>
  );
};
//IconBoxWhatsapp Whatsapp
export const IconBoxWhatsapp = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "29",
  height = "22",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.00535117 26.6667L1.80802 20.0427C0.620202 18.0065 -0.00385418 15.6907 1.79097e-05 13.3333C1.79097e-05 5.96933 5.96935 0 13.3334 0C20.6974 0 26.6667 5.96933 26.6667 13.3333C26.6667 20.6973 20.6974 26.6667 13.3334 26.6667C10.9771 26.6705 8.66223 26.0469 6.62668 24.86L0.00535117 26.6667ZM8.52135 7.07733C8.34917 7.08802 8.18092 7.13338 8.02669 7.21067C7.88205 7.29257 7.75001 7.39497 7.63468 7.51467C7.47468 7.66533 7.38402 7.796 7.28668 7.92267C6.7939 8.56399 6.52883 9.35122 6.53335 10.16C6.53602 10.8133 6.70668 11.4493 6.97335 12.044C7.51868 13.2467 8.41602 14.52 9.60135 15.7C9.88669 15.984 10.1654 16.2693 10.4654 16.5347C11.9365 17.83 13.6897 18.7641 15.5854 19.2627L16.344 19.3787C16.5907 19.392 16.8374 19.3733 17.0854 19.3613C17.4737 19.3413 17.8528 19.2361 18.196 19.0533C18.3706 18.9634 18.541 18.8655 18.7067 18.76C18.7067 18.76 18.764 18.7227 18.8734 18.64C19.0534 18.5067 19.164 18.412 19.3134 18.256C19.424 18.1413 19.52 18.0067 19.5934 17.8533C19.6974 17.636 19.8014 17.2213 19.844 16.876C19.876 16.612 19.8667 16.468 19.8627 16.3787C19.8574 16.236 19.7387 16.088 19.6094 16.0253L18.8334 15.6773C18.8334 15.6773 17.6734 15.172 16.9654 14.8493C16.8907 14.8168 16.8107 14.7983 16.7294 14.7947C16.6381 14.7853 16.546 14.7956 16.459 14.8248C16.3721 14.854 16.2924 14.9014 16.2254 14.964V14.9613C16.2187 14.9613 16.1294 15.0373 15.1654 16.2053C15.11 16.2797 15.0338 16.3359 14.9464 16.3667C14.859 16.3976 14.7644 16.4018 14.6747 16.3787C14.5878 16.3554 14.5027 16.326 14.42 16.2907C14.2547 16.2213 14.1974 16.1947 14.084 16.1453L14.0774 16.1427C13.3146 15.8096 12.6083 15.3598 11.984 14.8093C11.816 14.6627 11.66 14.5027 11.5 14.348C10.9755 13.8457 10.5183 13.2773 10.14 12.6573L10.0614 12.5307C10.0048 12.4456 9.95916 12.3537 9.92535 12.2573C9.87469 12.0613 10.0067 11.904 10.0067 11.904C10.0067 11.904 10.3307 11.5493 10.4814 11.3573C10.6068 11.1978 10.7239 11.0318 10.832 10.86C10.9894 10.6067 11.0387 10.3467 10.956 10.1453C10.5827 9.23333 10.196 8.32533 9.79868 7.424C9.72002 7.24533 9.48669 7.11733 9.27469 7.092C9.20269 7.084 9.13068 7.076 9.05868 7.07067C8.87963 7.06177 8.7002 7.06355 8.52135 7.076V7.07733Z"
        fill={colorIcon}
      />
    </svg>
  );
};
//IconBoxWeb Mundo vector
export const IconBoxWeb = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "29",
  height = "22",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.1467 16C19.2533 15.12 19.3333 14.24 19.3333 13.3333C19.3333 12.4267 19.2533 11.5467 19.1467 10.6667H23.6533C23.8667 11.52 24 12.4133 24 13.3333C24 14.2533 23.8667 15.1467 23.6533 16M16.7867 23.4133C17.5867 21.9333 18.2 20.3333 18.6267 18.6667H22.56C21.2682 20.891 19.2188 22.576 16.7867 23.4133M16.4533 16H10.2133C10.08 15.12 10 14.24 10 13.3333C10 12.4267 10.08 11.5333 10.2133 10.6667H16.4533C16.5733 11.5333 16.6667 12.4267 16.6667 13.3333C16.6667 14.24 16.5733 15.12 16.4533 16ZM13.3333 23.9467C12.2267 22.3467 11.3333 20.5733 10.7867 18.6667H15.88C15.3333 20.5733 14.44 22.3467 13.3333 23.9467ZM8 8H4.10667C5.38514 5.76962 7.43306 4.08198 9.86667 3.25333C9.06667 4.73333 8.46667 6.33333 8 8ZM4.10667 18.6667H8C8.46667 20.3333 9.06667 21.9333 9.86667 23.4133C7.43817 22.5756 5.39313 20.8903 4.10667 18.6667M3.01333 16C2.8 15.1467 2.66667 14.2533 2.66667 13.3333C2.66667 12.4133 2.8 11.52 3.01333 10.6667H7.52C7.41333 11.5467 7.33333 12.4267 7.33333 13.3333C7.33333 14.24 7.41333 15.12 7.52 16M13.3333 2.70667C14.44 4.30667 15.3333 6.09333 15.88 8H10.7867C11.3333 6.09333 12.2267 4.30667 13.3333 2.70667M22.56 8H18.6267C18.2094 6.34861 17.5914 4.75453 16.7867 3.25333C19.24 4.09333 21.28 5.78667 22.56 8ZM13.3333 0C5.96 0 0 6 0 13.3333C0 16.8696 1.40476 20.2609 3.90524 22.7614C5.14336 23.9995 6.61321 24.9817 8.23089 25.6517C9.84856 26.3218 11.5824 26.6667 13.3333 26.6667C16.8696 26.6667 20.2609 25.2619 22.7614 22.7614C25.2619 20.2609 26.6667 16.8696 26.6667 13.3333C26.6667 11.5824 26.3218 9.84856 25.6517 8.23089C24.9817 6.61321 23.9995 5.14336 22.7614 3.90524C21.5233 2.66713 20.0535 1.685 18.4358 1.01494C16.8181 0.344877 15.0843 0 13.3333 0V0Z"
        fill={colorIcon}
      />
    </svg>
  );
};
//IconBoxTakePicture Mundo vector
export const IconBoxTakePicture = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "29",
  height = "22",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 159 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.6393 18.2857V0H34.3989V18.2857H55.0382V30.4762H34.3989V48.7619H20.6393V30.4762H0V18.2857H20.6393ZM41.2786 54.8571V36.5714H61.918V18.2857H110.076L122.666 30.4762H144.475C152.043 30.4762 158.235 35.9619 158.235 42.6667V115.81C158.235 122.514 152.043 128 144.475 128H34.3989C26.8311 128 20.6393 122.514 20.6393 115.81V54.8571H41.2786ZM89.4371 109.714C108.425 109.714 123.836 96.061 123.836 79.2381C123.836 62.4152 108.425 48.7619 89.4371 48.7619C70.4489 48.7619 55.0382 62.4152 55.0382 79.2381C55.0382 96.061 70.4489 109.714 89.4371 109.714ZM67.4218 79.2381C67.4218 90.0267 77.2599 98.7429 89.4371 98.7429C101.614 98.7429 111.452 90.0267 111.452 79.2381C111.452 68.4495 101.614 59.7333 89.4371 59.7333C77.2599 59.7333 67.4218 68.4495 67.4218 79.2381Z"
        fill={colorIcon}
      />
    </svg>
  );
};
//IconBoxIllustrationForm documents big
export const IconBoxIllustrationForm = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "29",
  height = "22",
}) => {
  return (
    <svg
      width="239"
      height="291"
      viewBox="0 0 239 291"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1740_54815)">
        <path
          d="M224.146 4.97385L7.14062 11.875L15.9168 285.877L232.922 278.976L224.146 4.97385Z"
          fill="#292A2E"
        />
        <path
          opacity="0.58"
          d="M224.146 4.97385L7.14062 11.875L15.9168 285.877L232.922 278.976L224.146 4.97385Z"
          fill="white"
        />
        <path
          d="M216.212 0.196702L0.203125 17.9531L22.7921 290.796L238.801 273.04L216.212 0.196702Z"
          fill="white"
        />
        <path
          d="M216.04 0.400908L238.599 272.874L22.9603 290.599L0.402342 18.1263L216.041 0.400908M216.381 0L0 17.7867L22.6191 291L239 273.213L216.381 0Z"
          fill="black"
        />
        <path
          d="M201.515 19.4033L102.922 27.5078L103.51 34.6116L202.103 26.5071L201.515 19.4033Z"
          fill="#292A2E"
        />
        <path
          d="M203.193 38.745L104.562 46.8281L104.593 47.1986L203.224 39.1154L203.193 38.745Z"
          fill="black"
        />
        <path
          d="M204.271 51.7918L105.641 59.875L105.671 60.2454L204.302 52.1623L204.271 51.7918Z"
          fill="black"
        />
        <path
          d="M205.35 64.8387L106.719 72.9219L106.749 73.2923L205.38 65.2092L205.35 64.8387Z"
          fill="black"
        />
        <path
          d="M206.428 77.8856L107.797 85.9688L107.827 86.3392L206.458 78.256L206.428 77.8856Z"
          fill="black"
        />
        <path
          d="M153.179 95.3854L108.883 99.0156L108.913 99.3861L153.21 95.7558L153.179 95.3854Z"
          fill="black"
        />
        <path
          d="M209.154 111.653L25.4922 126.75L26.0803 133.854L209.742 118.756L209.154 111.653Z"
          fill="#292A2E"
        />
        <path
          d="M120.069 215.614L45.1016 221.758L45.1321 222.128L120.099 215.984L120.069 215.614Z"
          fill="black"
        />
        <path
          d="M121.342 230.966L46.375 237.109L46.4056 237.48L121.373 231.336L121.342 230.966Z"
          fill="black"
        />
        <path
          d="M122.608 246.317L47.6406 252.461L47.6712 252.831L122.638 246.688L122.608 246.317Z"
          fill="black"
        />
        <path
          d="M123.881 261.676L48.9141 267.82L48.9446 268.191L123.912 262.047L123.881 261.676Z"
          fill="black"
        />
        <path
          d="M37.2948 225.413C39.4726 225.413 41.2381 223.654 41.2381 221.484C41.2381 219.314 39.4726 217.555 37.2948 217.555C35.117 217.555 33.3516 219.314 33.3516 221.484C33.3516 223.654 35.117 225.413 37.2948 225.413Z"
          fill="#292A2E"
        />
        <path
          d="M41.1932 272.483C43.371 272.483 45.1365 270.724 45.1365 268.554C45.1365 266.384 43.371 264.625 41.1932 264.625C39.0155 264.625 37.25 266.384 37.25 268.554C37.25 270.724 39.0155 272.483 41.1932 272.483Z"
          fill="#292A2E"
        />
        <path
          d="M39.9198 257.132C42.0976 257.132 43.8631 255.373 43.8631 253.203C43.8631 251.033 42.0976 249.273 39.9198 249.273C37.742 249.273 35.9766 251.033 35.9766 253.203C35.9766 255.373 37.742 257.132 39.9198 257.132Z"
          fill="#292A2E"
        />
        <path
          d="M38.6073 241.272C40.7851 241.272 42.5506 239.513 42.5506 237.343C42.5506 235.173 40.7851 233.414 38.6073 233.414C36.4295 233.414 34.6641 235.173 34.6641 237.343C34.6641 239.513 36.4295 241.272 38.6073 241.272Z"
          fill="#292A2E"
        />
        <path
          d="M217.178 207.63L142.211 213.773L142.242 214.144L217.209 208L217.178 207.63Z"
          fill="black"
        />
        <path
          d="M218.452 222.981L143.484 229.125L143.515 229.495L218.482 223.352L218.452 222.981Z"
          fill="black"
        />
        <path
          d="M219.717 238.333L144.75 244.477L144.781 244.847L219.748 238.703L219.717 238.333Z"
          fill="black"
        />
        <path
          d="M220.991 253.692L146.023 259.836L146.054 260.206L221.021 254.063L220.991 253.692Z"
          fill="black"
        />
        <path
          d="M134.365 217.429C136.543 217.429 138.308 215.67 138.308 213.5C138.308 211.329 136.543 209.57 134.365 209.57C132.187 209.57 130.422 211.329 130.422 213.5C130.422 215.67 132.187 217.429 134.365 217.429Z"
          fill="#292A2E"
        />
        <path
          d="M138.264 264.499C140.441 264.499 142.207 262.74 142.207 260.57C142.207 258.4 140.441 256.641 138.264 256.641C136.086 256.641 134.32 258.4 134.32 260.57C134.32 262.74 136.086 264.499 138.264 264.499Z"
          fill="#292A2E"
        />
        <path
          d="M136.99 249.155C139.168 249.155 140.933 247.396 140.933 245.226C140.933 243.056 139.168 241.297 136.99 241.297C134.812 241.297 133.047 243.056 133.047 245.226C133.047 247.396 134.812 249.155 136.99 249.155Z"
          fill="#292A2E"
        />
        <path
          d="M135.678 233.296C137.855 233.296 139.621 231.537 139.621 229.367C139.621 227.197 137.855 225.438 135.678 225.438C133.5 225.438 131.734 227.197 131.734 229.367C131.734 231.537 133.5 233.296 135.678 233.296Z"
          fill="#292A2E"
        />
        <path
          d="M57.9563 70.2576C65.1248 70.2576 70.936 64.4671 70.936 57.3241C70.936 50.1811 65.1248 44.3906 57.9563 44.3906C50.7878 44.3906 44.9766 50.1811 44.9766 57.3241C44.9766 64.4671 50.7878 70.2576 57.9563 70.2576Z"
          fill="#B9DE2C"
        />
        <path
          d="M90.4631 89.2389C87.276 93.9708 83.06 97.9265 78.1284 100.812C73.1967 103.698 67.676 105.44 61.9762 105.909C56.2764 106.377 50.5438 105.56 45.2042 103.519C39.8646 101.477 35.0551 98.2634 31.1328 94.1159C34.2201 89.2594 38.3959 85.1827 43.3318 82.2061C48.2677 79.2296 53.8292 77.4344 59.5791 76.9618C65.329 76.4891 71.1105 77.3519 76.4692 79.4821C81.8279 81.6124 86.6177 84.9522 90.462 89.2389H90.4631Z"
          fill="#B9DE2C"
        />
        <path
          d="M58.8929 30.5122C68.6225 30.5227 77.9715 34.2798 84.9859 40.9984C92.0002 47.717 96.1372 56.8771 96.5319 66.564C96.9267 76.2509 93.5488 85.715 87.1043 92.9782C80.6597 100.241 71.6472 104.742 61.9506 105.538C60.9065 105.624 59.8494 105.667 58.8075 105.667C49.078 105.657 39.729 101.9 32.7146 95.1812C25.7002 88.4626 21.5633 79.3026 21.1685 69.6156C20.7737 59.9287 24.1516 50.4646 30.5962 43.2014C37.0407 35.9382 46.0532 31.438 55.7499 30.6415C56.7939 30.5557 57.8503 30.5122 58.8933 30.5122M58.8933 30.1406C57.844 30.1406 56.7842 30.1837 55.72 30.271C50.7356 30.6804 45.881 32.064 41.4332 34.343C36.9855 36.6219 33.0318 39.7515 29.798 43.553C26.5641 47.3545 24.1133 51.7535 22.5857 56.4988C21.058 61.2441 20.4834 66.2428 20.8945 71.2094V71.2094C21.6797 80.6941 26.0125 89.5386 33.0343 95.9897C40.056 102.441 49.254 106.028 58.8049 106.039C59.8544 106.039 60.9123 105.995 61.9785 105.908C66.9627 105.499 71.8172 104.115 76.2646 101.836C80.7121 99.5566 84.6655 96.427 87.8992 92.6255C91.1328 88.8241 93.5833 84.4251 95.1109 79.68C96.6384 74.9348 97.213 69.9363 96.8018 64.9699C96.0167 55.4852 91.6837 46.6406 84.6619 40.1895C77.6401 33.7385 68.442 30.1518 58.891 30.1406H58.8933Z"
          fill="black"
        />
        <path
          d="M210.983 132.856L27.25 147.914L27.2806 148.285L211.014 133.227L210.983 132.856Z"
          fill="black"
        />
        <path
          d="M211.984 145.842L28.3203 160.914L28.3509 161.284L212.015 146.212L211.984 145.842Z"
          fill="black"
        />
        <path
          d="M213.062 158.881L29.3984 173.953L29.429 174.323L213.093 159.251L213.062 158.881Z"
          fill="black"
        />
        <path
          d="M214.141 171.92L30.4766 186.992L30.5071 187.362L214.171 172.29L214.141 171.92Z"
          fill="black"
        />
        <path
          d="M75.8669 196.487L31.5703 200.117L31.6009 200.488L75.8975 196.857L75.8669 196.487Z"
          fill="black"
        />
        <path
          d="M24.6988 3.80337C26.1055 4.00963 27.3782 4.74861 28.2519 5.86644C29.1256 6.98427 29.5328 8.39481 29.3889 9.80437L27.4388 30.7972C27.3407 31.8983 26.808 32.9156 25.9576 33.6256C25.1073 34.3355 24.0089 34.68 22.9037 34.5834C21.8367 34.4651 20.8588 33.9346 20.1799 33.1058C19.501 32.2771 19.1752 31.2161 19.2726 30.1507L21.2783 8.56634C21.3333 7.88998 21.638 7.25797 22.1336 6.79256C22.6292 6.32716 23.2804 6.06144 23.9612 6.04683C24.3372 6.04576 24.7093 6.12291 25.0537 6.27336C25.3981 6.4238 25.7071 6.64422 25.9611 6.92051C26.2151 7.1968 26.4084 7.52288 26.5286 7.87788C26.6489 8.23287 26.6934 8.60898 26.6594 8.98211L25.2518 24.1334C25.2348 24.3158 25.1458 24.4841 25.0043 24.6011C24.8628 24.7182 24.6805 24.7745 24.4974 24.7576V24.7576C24.4067 24.7492 24.3185 24.7231 24.2379 24.6807C24.1573 24.6383 24.0859 24.5805 24.0278 24.5106C23.9696 24.4407 23.9259 24.36 23.899 24.2732C23.8722 24.1865 23.8628 24.0952 23.8714 24.0048L25.2734 8.91338C25.3098 8.58359 25.2228 8.25202 25.029 7.98221C24.8353 7.71241 24.5484 7.52336 24.2234 7.45131C24.0434 7.41666 23.8582 7.41991 23.6796 7.46086C23.501 7.50182 23.3329 7.57956 23.1863 7.68909C23.0396 7.79862 22.9176 7.93752 22.828 8.09686C22.7384 8.25619 22.6833 8.43244 22.6662 8.61427L20.6605 30.1994C20.5895 30.877 20.7733 31.5567 21.1764 32.1071C21.5794 32.6574 22.173 33.0392 22.8422 33.1786C23.2133 33.2489 23.595 33.2412 23.9629 33.156C24.3308 33.0708 24.6767 32.9099 24.9786 32.6837C25.2805 32.4576 25.5317 32.171 25.716 31.8425C25.9003 31.514 26.0138 31.1508 26.049 30.7761L28.0119 9.65091C28.1173 8.56293 27.7849 7.47775 27.0878 6.63379C26.3908 5.78982 25.386 5.25611 24.2942 5.14989C23.2357 5.07152 22.1885 5.41004 21.3778 6.09272C20.567 6.77539 20.0574 7.74773 19.9583 8.8008L18.274 26.9242C18.2656 27.0145 18.2395 27.1022 18.1971 27.1825C18.1546 27.2627 18.0967 27.3338 18.0267 27.3917C17.9567 27.4497 17.8759 27.4933 17.789 27.5201C17.702 27.5469 17.6107 27.5564 17.52 27.548C17.4294 27.5397 17.3413 27.5137 17.2607 27.4714C17.1801 27.4292 17.1087 27.3715 17.0506 27.3017C16.9924 27.2319 16.9486 27.1514 16.9216 27.0648C16.8947 26.9781 16.8852 26.887 16.8936 26.7967L18.5775 8.67335C18.6458 7.94801 18.8601 7.24381 19.2075 6.60282C19.555 5.96183 20.0286 5.3972 20.5999 4.94264C21.1713 4.48808 21.8287 4.15292 22.533 3.95718C23.2372 3.76144 23.9738 3.70913 24.6988 3.80337Z"
          fill="#B9DE2C"
        />
      </g>
      <defs>
        <clipPath id="clip0_1740_54815">
          <rect width="239" height="291" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

//IconBoxDevice Devise icono
export const IconBoxDevice = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "17",
  height = "20",
  style = null,
}) => {
  return (
    <svg
      style={style ? style : null}
      width={width}
      height={height}
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5721 5.43553C14.95 4.09455 14.0264 3.00023 12.8007 2.15322C11.8721 1.49144 10.7863 1.01901 9.54284 0.736708C8.34337 0.45413 7.03414 0.3125 4.00524 0.3125H0V19.691H4.88495C5.40674 19.691 5.86499 19.685 6.27379 19.6724C6.89334 19.6539 7.39989 19.6214 7.84183 19.5748C8.11699 19.5459 8.36705 19.5113 8.60401 19.4715C8.95966 19.4114 9.2861 19.3393 9.62129 19.255C10.1732 19.1328 10.7026 18.9647 11.2105 18.7499C11.2181 18.7469 11.2255 18.7436 11.2328 18.7404C11.6016 18.5834 11.9589 18.402 12.304 18.1959C12.4721 18.096 12.6373 17.99 12.7999 17.8783C12.8354 17.8533 12.8708 17.828 12.9058 17.8025C13.5428 17.3396 14.0961 16.813 14.5649 16.2226C14.9604 15.7256 15.2958 15.1832 15.5719 14.5958C16.2022 13.2455 16.5176 11.7189 16.5176 10.0154C16.5176 8.31192 16.2022 6.78573 15.5719 5.43553H15.5721ZM5.21485 13.039L5.22727 16.0969H2.00975V2.78211H5.00526C7.27062 2.78211 8.24995 2.89011 9.14693 3.10498C10.077 3.32009 10.8891 3.67984 11.5834 4.18334C12.5002 4.8282 13.191 5.66127 13.6565 6.68238C14.1278 7.71016 14.3638 8.87242 14.3638 10.1689C14.3638 11.4653 14.1278 12.6278 13.6565 13.6554C13.2046 14.6343 12.5397 15.4481 11.6623 16.0969V7.9211H8.44482V11.1385H5.22727V12.8524C5.22727 12.9157 5.22289 12.9781 5.21485 13.039Z"
        fill={colorIcon}
      />
    </svg>
  );
};
//IconBoxArrowUp Flecha arriba
export const IconBoxArrowUp = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "15",
  height = "17",
  style = null,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.0009 6.56069L7.57467 1.70469L13.1484 6.56069M7.57467 15.3047L7.57467 1.84069"
        stroke="#1C4FC1"
        strokeWidth="2.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
//IconBoxArrowDiagonal flecha diagonal
export const IconBoxArrowDiagonal = ({
  colorIcon = "#1C4FC1",
  colorName = "#252772",
  width = "18",
  height = "19",
  style = null,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 -960 960 960"
      width={width}
      fill={colorIcon}
    >
      <path d="m216-160-56-56 464-464H360v-80h400v400h-80v-264L216-160Z" />
    </svg>
  );
};
//IconBoxArrowDiagonal flecha abajo
export const IconBoxArrowDown = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "22",
  height = "19",
  style = null,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5772 10.244L11.0035 15.1L5.42969 10.244M11.0035 1.5L11.0035 14.964"
        stroke="#1C4FC1"
        strokeWidth="2.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 17.5H21"
        stroke="#1C4FC1"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const IconBoxWallet = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "22",
  height = "19",
  style = null,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66406 5.07723H20.2891C20.4716 5.07714 20.6539 5.08872 20.835 5.1119C20.7736 4.68112 20.6256 4.26724 20.4 3.89519C20.1743 3.52315 19.8757 3.20066 19.522 2.94715C19.1684 2.69365 18.767 2.51439 18.3422 2.42019C17.9174 2.32598 17.478 2.31878 17.0503 2.39901L4.2002 4.59286H4.18555C3.37894 4.7471 2.66165 5.20346 2.18018 5.86873C2.90556 5.35278 3.7739 5.07608 4.66406 5.07723ZM20.2891 6.24911H4.66406C3.83554 6.25001 3.04121 6.57954 2.45535 7.1654C1.8695 7.75125 1.53997 8.54558 1.53906 9.37411V18.7491C1.53997 19.5776 1.8695 20.372 2.45535 20.9578C3.04121 21.5437 3.83554 21.8732 4.66406 21.8741H20.2891C21.1176 21.8732 21.9119 21.5437 22.4978 20.9578C23.0836 20.372 23.4132 19.5776 23.4141 18.7491V9.37411C23.4132 8.54558 23.0836 7.75125 22.4978 7.1654C21.9119 6.57954 21.1176 6.25001 20.2891 6.24911ZM17.9697 15.6241C17.6607 15.6241 17.3586 15.5325 17.1016 15.3608C16.8447 15.1891 16.6444 14.9451 16.5262 14.6595C16.4079 14.374 16.377 14.0599 16.4372 13.7568C16.4975 13.4537 16.6464 13.1753 16.8649 12.9568C17.0834 12.7382 17.3618 12.5894 17.6649 12.5291C17.968 12.4688 18.2822 12.4998 18.5677 12.618C18.8532 12.7363 19.0972 12.9366 19.2689 13.1935C19.4406 13.4505 19.5322 13.7526 19.5322 14.0616C19.5322 14.476 19.3676 14.8734 19.0746 15.1665C18.7816 15.4595 18.3841 15.6241 17.9697 15.6241Z"
        fill={colorIcon}
      />
      <path
        d="M1.5625 12.6719V7.81348C1.5625 6.75537 2.14844 4.98145 4.18213 4.59717C5.9082 4.27344 7.61719 4.27344 7.61719 4.27344C7.61719 4.27344 8.74023 5.05469 7.8125 5.05469C6.88477 5.05469 6.90918 6.25098 7.8125 6.25098C8.71582 6.25098 7.8125 7.39844 7.8125 7.39844L4.1748 11.5244L1.5625 12.6719Z"
        fill={colorIcon}
      />
    </svg>
  );
};

export const IconBoxReload = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "23",
  height = "23",
  style = null,
}) => {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      class="ionicon"
      viewBox="0 0 512 512"
    >
      <path
        d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
        fill="none"
        stroke={colorIcon}
        stroke-miterlimit="10"
        stroke-width="32"
      />
      <path
        d="M341.54 197.85l-11.37-13.23a103.37 103.37 0 1022.71 105.84"
        fill="none"
        stroke={colorIcon}
        strokeLinecap="round"
        stroke-miterlimit="10"
        stroke-width="32"
      />
      <path
        fill={colorIcon}
        d="M367.32 162a8.44 8.44 0 00-6 2.54l-59.54 59.54a8.61 8.61 0 006.09 14.71h59.54a8.62 8.62 0 008.62-8.62v-59.56a8.61 8.61 0 00-8.68-8.63z"
      />
    </svg>
  );
};

export const IconBoxReloadOutLine = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "23",
  height = "23",
  style = null,
}) => {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      className="ionicon"
      viewBox="0 0 512 512"
    >
      <path
        d="M400 148l-21.12-24.57A191.43 191.43 0 00240 64C134 64 48 150 48 256s86 192 192 192a192.09 192.09 0 00181.07-128"
        fill="none"
        stroke={colorIcon}
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="32"
      />
      <path
        fill={colorIcon}
        d="M464 97.42V208a16 16 0 01-16 16H337.42c-14.26 0-21.4-17.23-11.32-27.31L436.69 86.1C446.77 76 464 83.16 464 97.42z"
      />
    </svg>
  );
};

export const IconBoxArea = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "29",
  height = "22",
  style = null,
}) => {
  return (
    <svg
      width={width} //"47"
      height={height} //"44"
      viewBox="0 0 47 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style ? style : null}
    >
      <g clipPath="url(#clip0_1904_22895)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.9001 11.8454C13.8998 11.945 13.8717 12.0426 13.8188 12.127C13.7659 12.2114 13.6905 12.2793 13.601 12.3231C13.5115 12.3668 13.4116 12.3846 13.3125 12.3745C13.2134 12.3643 13.1192 12.3267 13.0404 12.2657L9.64198 9.62251C9.57814 9.57262 9.5265 9.50885 9.49099 9.43603C9.45547 9.36321 9.43701 9.28326 9.43701 9.20224C9.43701 9.12122 9.45547 9.04127 9.49099 8.96845C9.5265 8.89563 9.57814 8.83185 9.64198 8.78197L13.0404 6.13664C13.1194 6.07546 13.2141 6.03773 13.3136 6.02775C13.413 6.01778 13.5133 6.03596 13.6029 6.08022C13.6926 6.12448 13.768 6.19304 13.8205 6.27808C13.873 6.36311 13.9006 6.46121 13.9001 6.56117V8.13984H26.7001V6.55691C26.7001 6.45694 26.7282 6.35897 26.7811 6.27419C26.8341 6.1894 26.9098 6.12121 26.9997 6.07739C27.0896 6.03358 27.1899 6.0159 27.2893 6.02637C27.3888 6.03685 27.4832 6.07506 27.562 6.13664L30.9583 8.77984C31.0221 8.82972 31.0737 8.89349 31.1093 8.96631C31.1448 9.03913 31.1632 9.11909 31.1632 9.20011C31.1632 9.28113 31.1448 9.36108 31.1093 9.4339C31.0737 9.50672 31.0221 9.57049 30.9583 9.62037L27.562 12.2657C27.4831 12.3274 27.3884 12.3656 27.2888 12.376C27.1892 12.3864 27.0887 12.3686 26.9987 12.3245C26.9088 12.2804 26.8331 12.2119 26.7803 12.1268C26.7275 12.0417 26.6997 11.9435 26.7001 11.8433V10.2689H13.9001V11.8454ZM27.7668 16.6689H12.8335C12.5506 16.6689 12.2792 16.7813 12.0792 16.9813C11.8792 17.1814 11.7668 17.4527 11.7668 17.7356V32.6689C11.7668 32.9518 11.8792 33.2231 12.0792 33.4232C12.2792 33.6232 12.5506 33.7356 12.8335 33.7356H27.7668C28.0497 33.7356 28.321 33.6232 28.521 33.4232C28.7211 33.2231 28.8335 32.9518 28.8335 32.6689V17.7356C28.8335 17.4527 28.7211 17.1814 28.521 16.9813C28.321 16.7813 28.0497 16.6689 27.7668 16.6689ZM12.8335 14.5356C11.9848 14.5356 11.1708 14.8727 10.5707 15.4728C9.97059 16.0729 9.63345 16.8869 9.63345 17.7356V32.6689C9.63345 33.5176 9.97059 34.3315 10.5707 34.9316C11.1708 35.5318 11.9848 35.8689 12.8335 35.8689H27.7668C28.6155 35.8689 29.4294 35.5318 30.0295 34.9316C30.6296 34.3315 30.9668 33.5176 30.9668 32.6689V17.7356C30.9668 16.8869 30.6296 16.0729 30.0295 15.4728C29.4294 14.8727 28.6155 14.5356 27.7668 14.5356H12.8335ZM38.9433 18.8022H37.3668V31.6022H38.9433C39.0429 31.6025 39.1405 31.6307 39.2249 31.6836C39.3093 31.7364 39.3772 31.8119 39.4209 31.9013C39.4647 31.9908 39.4825 32.0908 39.4724 32.1899C39.4622 32.2889 39.4245 32.3832 39.3636 32.462L36.7204 35.8604C36.6705 35.9242 36.6067 35.9759 36.5339 36.0114C36.4611 36.0469 36.3811 36.0653 36.3001 36.0653C36.2191 36.0653 36.1391 36.0469 36.0663 36.0114C35.9935 35.9759 35.9297 35.9242 35.8799 35.8604L33.2345 32.462C33.1735 32.3831 33.1357 32.2886 33.1257 32.1893C33.1156 32.09 33.1336 31.9899 33.1776 31.9004C33.2216 31.8108 33.2899 31.7354 33.3746 31.6827C33.4593 31.63 33.5571 31.6021 33.6569 31.6022H35.2335V18.8022H33.6569C33.5573 18.802 33.4598 18.7738 33.3754 18.7209C33.291 18.6681 33.223 18.5926 33.1793 18.5031C33.1356 18.4137 33.1177 18.3137 33.1279 18.2146C33.138 18.1155 33.1757 18.0213 33.2367 17.9425L35.8799 14.5441C35.9297 14.4803 35.9935 14.4286 36.0663 14.3931C36.1391 14.3576 36.2191 14.3391 36.3001 14.3391C36.3811 14.3391 36.4611 14.3576 36.5339 14.3931C36.6067 14.4286 36.6705 14.4803 36.7204 14.5441L39.3657 17.9425C39.4268 18.0214 39.4645 18.1159 39.4745 18.2152C39.4846 18.3144 39.4666 18.4145 39.4226 18.5041C39.3786 18.5936 39.3104 18.6691 39.2256 18.7218C39.1409 18.7745 39.0431 18.8024 38.9433 18.8022V18.8022Z"
          fill="#B9DE2C"
        />
      </g>
      <defs>
        <clipPath id="clip0_1904_22895">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(7.5 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconBoxBuild = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "29",
  height = "22",
  style = null,
}) => {
  return (
    <svg
      style={style ? style : null}
      width={width}
      height={height}
      viewBox="0 0 47 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.2812 11.125H33.4688V9.67545C33.4688 8.97719 32.944 8.40625 32.3042 8.40625H26.4752C25.8372 8.40625 25.3125 8.97719 25.3125 9.67545V11.125H14.4108L11.7188 16.5625H13.5879V20.1875H13.2852L11.7754 22L13.2852 23.8125H13.616V24.7858C13.616 25.0319 13.8058 25.2308 14.041 25.2308C14.7438 25.2308 15.3157 25.8307 15.3157 26.568C15.3157 27.3052 14.7438 27.9051 14.041 27.9051C13.3382 27.9051 12.7664 27.3052 12.7664 26.568C12.7664 26.3219 12.5761 26.123 12.3413 26.123C12.1062 26.123 11.9163 26.3219 11.9163 26.568C11.9172 27.7977 12.8697 28.7969 14.041 28.7969C15.2119 28.7969 16.1653 27.7977 16.1653 26.5684C16.1653 25.4922 15.4344 24.5914 14.466 24.3852V23.8125H14.7964L16.3066 22L14.7964 20.1875H14.4941V16.5625H25.3125V19.8245C25.3125 20.4263 25.7026 20.9306 26.2188 21.0602V35.5938H27.4082V32.875L31.373 34.2344L27.4082 35.5938H32.5625V21.0598C33.0791 20.9306 33.4688 20.4263 33.4688 19.8245V16.5625H35.2812V15.2031H34.3397L35.2812 13.4155V11.125ZM13.8226 15.2031L14.8811 13.0286L16.0257 15.2031H13.8226ZM15.8263 12.4844H17.7082L16.7675 14.272L15.8263 12.4844ZM17.5092 15.2031L18.4504 13.4155L19.392 15.2031H17.5092ZM19.1926 12.4844H21.0744L20.1333 14.272L19.1926 12.4844ZM20.876 15.2031L21.8166 13.4155L22.7573 15.2031H20.876ZM22.5589 12.4844H24.4407L23.5 14.272L22.5589 12.4844ZM25.3125 15.2031H24.2418L25.1825 13.4155L25.3125 13.6625V15.2031ZM31.373 32.875L27.4082 31.5156L31.373 30.1562V32.875ZM27.4082 30.1562V27.4375L31.373 28.7978L27.4082 30.1562ZM31.373 27.4375L27.4082 26.0781L31.373 24.7188V27.4375ZM27.4082 24.7188V22.0009L31.373 23.3594L27.4082 24.7188ZM31.373 22.0009L28.7291 21.0938H31.373V22.0009ZM32.0527 14.4093C32.0527 14.8456 31.7464 15.2031 31.373 15.2031H27.294C26.9206 15.2031 26.6152 14.8456 26.6152 14.4093V10.5622C26.6152 10.1231 26.9206 9.76562 27.294 9.76562H31.373C31.7464 9.76562 32.0527 10.1231 32.0527 10.5622V14.4093ZM33.5979 14.272L33.4688 14.0264V12.4844H34.5386L33.5979 14.272Z"
        fill="#B9DE2C"
      />
    </svg>
  );
};
export const IconBoxDimensions = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "29",
  height = "22",
  style = null,
}) => {
  return (
    <svg
      style={style ? style : null}
      width={width}
      height={height}
      viewBox="0 0 47 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1667 10H11.5V12.6667H14.1667V10ZM16.8333 10H19.5V12.6667H16.8333V10ZM24.8333 10H22.1667V12.6667H24.8333V10ZM27.5 10H30.1667V12.6667H27.5V10ZM32.8333 10H35.5V12.6667H32.8333V10ZM11.5 15.3333H14.1667V18H11.5V15.3333ZM14.1667 20.6667H11.5V23.3333H14.1667V20.6667ZM11.5 26H14.1667V28.6667H11.5V26ZM14.1667 31.3333H11.5V34H14.1667V31.3333ZM16.8333 31.3333H19.5V34H16.8333V31.3333ZM24.8333 31.3333H22.1667V34H24.8333V31.3333ZM32.8333 20.6667H35.5V23.3333H32.8333V20.6667ZM35.5 15.3333H32.8333V18H35.5V15.3333ZM27.5 28.6667V26H35.5V28.6667H32.8333V31.3333H30.1667V34H27.5V28.6667ZM32.8333 31.3333V34H35.5V31.3333H32.8333Z"
        fill="#B9DE2C"
      />
    </svg>
  );
};

export const IconBoxCualification = ({
  colorIcon = "#B9DE2C",
  colorName = "#252772",
  width = "29",
  height = "22",
  style = null,
}) => {
  return (
    <svg
      style={style ? style : null}
      width={width}
      height={height}
      viewBox="0 0 47 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5711 10.9174L23.5 8.71094L33.4289 10.9174C33.6972 10.977 33.9372 11.1264 34.1092 11.3408C34.2812 11.5552 34.375 11.8218 34.375 12.0967V24.1643C34.3749 25.3578 34.0802 26.5329 33.5169 27.5851C32.9537 28.6374 32.1394 29.5343 31.1463 30.1963L23.5 35.2943L15.8537 30.1963C14.8607 29.5344 14.0466 28.6377 13.4833 27.5856C12.9201 26.5336 12.6253 25.3588 12.625 24.1655V12.0967C12.625 11.8218 12.7188 11.5552 12.8908 11.3408C13.0628 11.1264 13.3028 10.977 13.5711 10.9174ZM23.5 23.8151L27.0513 25.682L26.3734 21.7283L29.2456 18.9274L25.275 18.3498L23.5 14.7526L21.7237 18.3498L17.7544 18.9274L20.6266 21.7283L19.9499 25.682L23.5 23.8151Z"
        fill="#B9DE2C"
      />
    </svg>
  );
};

//Icono de ver más
export const IconViewMore = ({
  colorIcon = "#CBE661",
  width = "20",
  height = "20",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.22222 20C1.61111 20 1.08796 19.7824 0.652778 19.3472C0.217593 18.912 0 18.3889 0 17.7778V2.22222C0 1.61111 0.217593 1.08796 0.652778 0.652778C1.08796 0.217593 1.61111 0 2.22222 0H10V2.22222H2.22222V17.7778H17.7778V10H20V17.7778C20 18.3889 19.7824 18.912 19.3472 19.3472C18.912 19.7824 18.3889 20 17.7778 20H2.22222ZM7.44444 14.1111L5.88889 12.5556L16.2222 2.22222H12.2222V0H20V7.77778H17.7778V3.77778L7.44444 14.1111Z"
        fill="#CBE661"
      />
    </svg>
  );
};

//Icono de store
export const IconStoreFront = ({
  width = "20",
  height = "20",
  color = "#B9DE2C",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 -960 960 960"
      width={width}
      fill={color}
    >
      <path d="M841-518v318q0 33-23.5 56.5T761-120H201q-33 0-56.5-23.5T121-200v-318q-23-21-35.5-54t-.5-72l42-136q8-26 28.5-43t47.5-17h556q27 0 47 16.5t29 43.5l42 136q12 39-.5 71T841-518Zm-272-42q27 0 41-18.5t11-41.5l-22-140h-78v148q0 21 14 36.5t34 15.5Zm-180 0q23 0 37.5-15.5T441-612v-148h-78l-22 140q-4 24 10.5 42t37.5 18Zm-178 0q18 0 31.5-13t16.5-33l22-154h-78l-40 134q-6 20 6.5 43t41.5 23Zm540 0q29 0 42-23t6-43l-42-134h-76l22 154q3 20 16.5 33t31.5 13ZM201-200h560v-282q-5 2-6.5 2H751q-27 0-47.5-9T663-518q-18 18-41 28t-49 10q-27 0-50.5-10T481-518q-17 18-39.5 28T393-480q-29 0-52.5-10T299-518q-21 21-41.5 29.5T211-480h-4.5q-2.5 0-5.5-2v282Zm560 0H201h560Z" />
    </svg>
  );
};

//Icono rango de fecha
export const IconDateRange = ({
  width = "20",
  height = "20",
  color = "#B9DE2C",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 -960 960 960"
      width={width}
      fill={color}
    >
      <path d="M320-400q-17 0-28.5-11.5T280-440q0-17 11.5-28.5T320-480q17 0 28.5 11.5T360-440q0 17-11.5 28.5T320-400Zm160 0q-17 0-28.5-11.5T440-440q0-17 11.5-28.5T480-480q17 0 28.5 11.5T520-440q0 17-11.5 28.5T480-400Zm160 0q-17 0-28.5-11.5T600-440q0-17 11.5-28.5T640-480q17 0 28.5 11.5T680-440q0 17-11.5 28.5T640-400ZM200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Z" />
    </svg>
  );
};

//Icono alarma
export const IconAlarm = ({
  width = "20",
  height = "20",
  color = "#B9DE2C",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 -960 960 960"
      width={width}
      fill={color}
    >
      <path d="M480-80q-75 0-140.5-28.5t-114-77q-48.5-48.5-77-114T120-440q0-75 28.5-140.5t77-114q48.5-48.5 114-77T480-800q75 0 140.5 28.5t114 77q48.5 48.5 77 114T840-440q0 75-28.5 140.5t-77 114q-48.5 48.5-114 77T480-80Zm0-360Zm112 168 56-56-128-128v-184h-80v216l152 152ZM224-866l56 56-170 170-56-56 170-170Zm512 0 170 170-56 56-170-170 56-56ZM480-160q117 0 198.5-81.5T760-440q0-117-81.5-198.5T480-720q-117 0-198.5 81.5T200-440q0 117 81.5 198.5T480-160Z" />
    </svg>
  );
};

//Icon pig savings
export const IconPigSaving = ({
  width = "20",
  height = "20",
  color = "#B9DE2C",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 -960 960 960"
      width={width}
      fill={color}
    >
      <path d="M640-520q17 0 28.5-11.5T680-560q0-17-11.5-28.5T640-600q-17 0-28.5 11.5T600-560q0 17 11.5 28.5T640-520Zm-320-80h200v-80H320v80ZM180-120q-34-114-67-227.5T80-580q0-92 64-156t156-64h200q29-38 70.5-59t89.5-21q25 0 42.5 17.5T720-820q0 6-1.5 12t-3.5 11q-4 11-7.5 22.5T702-751l91 91h87v279l-113 37-67 224H480v-80h-80v80H180Zm60-80h80v-80h240v80h80l62-206 98-33v-141h-40L620-720q0-20 2.5-38.5T630-796q-29 8-51 27.5T547-720H300q-58 0-99 41t-41 99q0 98 27 191.5T240-200Zm240-298Z" />
    </svg>
  );
};

//Icon doble tuerca
export const IconNuts = ({
  width = "20",
  height = "20",
  color = "#B9DE2C",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 -960 960 960"
      width={width}
      fill={color}
    >
      <path d="m234-480-12-60q-12-5-22.5-10.5T178-564l-58 18-40-68 46-40q-2-13-2-26t2-26l-46-40 40-68 58 18q11-8 21.5-13.5T222-820l12-60h80l12 60q12 5 22.5 10.5T370-796l58-18 40 68-46 40q2 13 2 26t-2 26l46 40-40 68-58-18q-11 8-21.5 13.5T326-540l-12 60h-80Zm40-120q33 0 56.5-23.5T354-680q0-33-23.5-56.5T274-760q-33 0-56.5 23.5T194-680q0 33 23.5 56.5T274-600ZM592-40l-18-84q-17-6-31.5-14.5T514-158l-80 26-56-96 64-56q-2-18-2-36t2-36l-64-56 56-96 80 26q14-11 28.5-19.5T574-516l18-84h112l18 84q17 6 31.5 14.5T782-482l80-26 56 96-64 56q2 18 2 36t-2 36l64 56-56 96-80-26q-14 11-28.5 19.5T722-124l-18 84H592Zm56-160q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35Z" />
    </svg>
  );
};

//Icon money
export const IconAttachMoney = ({
  width = "20",
  height = "20",
  color = "#B9DE2C",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 -960 960 960"
      width={width}
      fill={color}
    >
      <path d="M441-120v-86q-53-12-91.5-46T293-348l74-30q15 48 44.5 73t77.5 25q41 0 69.5-18.5T587-356q0-35-22-55.5T463-458q-86-27-118-64.5T313-614q0-65 42-101t86-41v-84h80v84q50 8 82.5 36.5T651-650l-74 32q-12-32-34-48t-60-16q-44 0-67 19.5T393-614q0 33 30 52t104 40q69 20 104.5 63.5T667-358q0 71-42 108t-104 46v84h-80Z" />
    </svg>
  );
};

//Icon unidad
export const IconUnits = ({
  width = "20",
  height = "20",
  color = "#B9DE2C",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 -960 960 960"
      width={width}
      fill={color}
    >
      <path d="M480-280h80v-400H400v80h80v320ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z" />
    </svg>
  );
};
//icono de barras verticales
export const IconVerticalBar = ({
  width = "20",
  height = "20",
  color = "#B9DE2C",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 -960 960 960"
      width={width}
      fill={color}
    >
      <path d="M200-160v-240h120v240H200Zm240 0v-440h120v440H440Zm240 0v-640h120v640H680Z" />
    </svg>
  );
};
//icon graph line
export const IconGraphLine = ({
  width = "20",
  height = "20",
  color = "#B9DE2C",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 -960 960 960"
      width={width}
      fill={color}
    >
      <path d="m140-220-60-60 300-300 160 160 284-320 56 56-340 384-160-160-240 240Z" />
    </svg>
  );
};
//Icon archivo
export const IconInventory = ({
  width = "20",
  height = "20",
  color = "#B9DE2C",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 -960 960 960"
      width={width}
      fill={color}
    >
      <path d="M200-80q-33 0-56.5-23.5T120-160v-451q-18-11-29-28.5T80-680v-120q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v120q0 23-11 40.5T840-611v451q0 33-23.5 56.5T760-80H200Zm0-520v440h560v-440H200Zm-40-80h640v-120H160v120Zm200 280h240v-80H360v80Zm120 20Z" />
    </svg>
  );
};
//Icono apreton de manos
export const IconHandShake = ({
  width = "20",
  height = "20",
  color = "#B9DE2C",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 -960 960 960"
      width={width}
      fill={color}
    >
      <path d="M475-160q4 0 8-2t6-4l328-328q12-12 17.5-27t5.5-30q0-16-5.5-30.5T817-607L647-777q-11-12-25.5-17.5T591-800q-15 0-30 5.5T534-777l-11 11 74 75q15 14 22 32t7 38q0 42-28.5 70.5T527-522q-20 0-38.5-7T456-550l-75-74-175 175q-3 3-4.5 6.5T200-435q0 8 6 14.5t14 6.5q4 0 8-2t6-4l136-136 56 56-135 136q-3 3-4.5 6.5T285-350q0 8 6 14t14 6q4 0 8-2t6-4l136-135 56 56-135 136q-3 2-4.5 6t-1.5 8q0 8 6 14t14 6q4 0 7.5-1.5t6.5-4.5l136-135 56 56-136 136q-3 3-4.5 6.5T454-180q0 8 6.5 14t14.5 6Zm-1 80q-37 0-65.5-24.5T375-166q-34-5-57-28t-28-57q-34-5-56.5-28.5T206-336q-38-5-62-33t-24-66q0-20 7.5-38.5T149-506l232-231 131 131q2 3 6 4.5t8 1.5q9 0 15-5.5t6-14.5q0-4-1.5-8t-4.5-6L398-777q-11-12-25.5-17.5T342-800q-15 0-30 5.5T285-777L144-635q-9 9-15 21t-8 24q-2 12 0 24.5t8 23.5l-58 58q-17-23-25-50.5T40-590q2-28 14-54.5T87-692l141-141q24-23 53.5-35t60.5-12q31 0 60.5 12t52.5 35l11 11 11-11q24-23 53.5-35t60.5-12q31 0 60.5 12t52.5 35l169 169q23 23 35 53t12 61q0 31-12 60.5T873-437L545-110q-14 14-32.5 22T474-80Zm-99-560Z" />
    </svg>
  );
};
//Icono lock, candado
export const IconLock = ({
  width = "20",
  height = "20",
  color = "#B9DE2C",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 -960 960 960"
      width={width}
      fill={color}
    >
      <path d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm0-80h480v-400H240v400Zm240-120q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80ZM240-160v-400 400Z" />
    </svg>
  );
};
//Icono mas o menos
export const IconMinusPlus = ({
  width = "20",
  height = "20",
  color = "#B9DE2C",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 29 11"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.0714 0C23.0714 0 23.0714 5.92318 23.0714 11M28.5 5.5C23.8137 5.5 22.1863 5.5 17.5 5.5M11 5.5C6.31371 5.5 4.68629 5.5 0 5.5"
        stroke="#5B6576"
        stroke-width="2"
      />
    </svg>
  );
};

//Icono archivo
export const IconFileEarmark = ({
  width = "20",
  height = "20",
  color = "#B9DE2C",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={color}
      class="bi bi-file-earmark"
      viewBox="0 0 16 16"
    >
      <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5z" />
    </svg>
  );
};
